import { FormattedMessage } from 'react-intl';

import styles from './TimeoutSessionErrorModal.module.css';
import { reloadCurrentLocation } from '../../../iwRouter/LocationHelper';
import { RefreshSVG } from '../../../svgComponents/refreshSVG';

const TimeoutSessionErrorModal = () => {
    return (
        <div className={styles.TimeoutSessionErrorModal}>
            <RefreshSVG className={styles.icon} />
            <div className={styles.label}>
                <FormattedMessage
                    id="_.modal.timeout_session_error.label"
                    defaultMessage="It looks like your session timed out"
                />
            </div>
            <button
                className={styles.button}
                onClick={() => reloadCurrentLocation()}
            >
                <FormattedMessage
                    id="_.modal.timeout_session_error.refresh"
                    defaultMessage="Refresh"
                />
            </button>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default TimeoutSessionErrorModal;
